import { render, staticRenderFns } from "./unidadesdemedida.vue?vue&type=template&id=f9f96958&"
import script from "./unidadesdemedida.vue?vue&type=script&lang=js&"
export * from "./unidadesdemedida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports